// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styling for login page */

/* TODO: Responsive styling! */

#login-page {
    background-image: linear-gradient(var(--yellow), var(--dark-purple));
    height: 100vh;
  }

#login-container {
    width: 100vw;
    height: 100vh;

    display: flex;
    justify-content: center;
    align-items: center;
}
  
#login-panel {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    padding: 5vw;

    box-shadow: 15px 15px 30px rgba(0, 0, 0, 0.1);

    width: 100%;
    height: 100%;
}

#login-greeting, #login-form {
    width: 50%;

    height: 100%;

    padding: 10px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

#login-greeting *, #login-form * {
    width: 70%;

    margin: 0;
}

#login-greeting {
    background-color: white;
    color: black;

    border-radius: 10px 0 0 10px;

    text-align: center;

    gap: 10%;
}

#login-form form {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

#logo-tagline {
    display: flex;
    flex-direction: column;
    align-items: center;

    font-weight: normal;
}

#login-logo {
    max-width: 100%;
    margin: 20px;
}

#expedition-buttons {
    display: flex;
    flex-direction: row;
    /* flex-wrap: wrap; */
    gap: 25px;
    justify-content: center;
}

#expedition-buttons > div {
    margin: 0;
    padding: 0;
}

#expedition-buttons button {
    margin: 0;

    height: 15vh;
    width: 15vh;

    border-radius: 10px;
    border-style: none;

    background-image: linear-gradient(var(--pink), var(--blue));

    color: white;
}

#login-form {
    background-color: var(--light-purple);
    color: white;

    border-radius: 0 10px 10px 0;

    gap: 20px;
}

#responsive-logo {
    display: none;
}

#login-form h3 {
    font-weight: bold;
    font-size: 5vh;

    margin: 5px;
}

#login-form .label {
    font-size: 3vh;
}

#login-form #validated-username {
    font-size: 2.5vh;
}

.login-credentials {
    font-size: 3vh;

    padding: 5px;
    margin-top: 5px !important;
    margin-bottom: 5px !important;

    width: 100% !important;
}

#login-button {
    background-color: var(--yellow)!important;
    color: white;

    font-size: 3vh;

    border-style: none;
    border-radius: 5px;

    padding: 10px;
}

/* Styling for screen sizes under 480px - mobile interface */
@media screen and (max-width: 800px) {
    #login-panel {
        flex-direction: column;
        width: 85vw;
        height: 85vh;
        padding: 0;
        margin: 0;
        gap: 0;
    }

    #login-greeting, #login-form {
        width: 100%;
        margin: 0;
    }

    #login-greeting {
        /* border-radius: 10px 10px 0 0; */
        display: none;
    }

    #logo-tagline h3 {
        display: none;
    }

    #login-form {
        background-color: white;
        color: black;
        border-radius: 10px;
    }

    #responsive-logo {
        display: block;
        height: 6vh;
        width: auto;
    }

    #login-form > h3 {
        font-size: 4vh;
        font-weight: normal;
    }

    #login-form > p {
        font-size: 2vh;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/LoginPage.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B,8BAA8B;;AAE9B;IACI,oEAAoE;IACpE,aAAa;EACf;;AAEF;IACI,YAAY;IACZ,aAAa;;IAEb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;;IAEnB,YAAY;;IAEZ,6CAA6C;;IAE7C,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;;IAEV,YAAY;;IAEZ,aAAa;;IAEb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;;IAEV,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,YAAY;;IAEZ,4BAA4B;;IAE5B,kBAAkB;;IAElB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;IAEnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,SAAS;;IAET,YAAY;IACZ,WAAW;;IAEX,mBAAmB;IACnB,kBAAkB;;IAElB,2DAA2D;;IAE3D,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,YAAY;;IAEZ,4BAA4B;;IAE5B,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,cAAc;;IAEd,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;;IAEd,YAAY;IACZ,0BAA0B;IAC1B,6BAA6B;;IAE7B,sBAAsB;AAC1B;;AAEA;IACI,yCAAyC;IACzC,YAAY;;IAEZ,cAAc;;IAEd,kBAAkB;IAClB,kBAAkB;;IAElB,aAAa;AACjB;;AAEA,4DAA4D;AAC5D;IACI;QACI,sBAAsB;QACtB,WAAW;QACX,YAAY;QACZ,UAAU;QACV,SAAS;QACT,MAAM;IACV;;IAEA;QACI,WAAW;QACX,SAAS;IACb;;IAEA;QACI,kCAAkC;QAClC,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,uBAAuB;QACvB,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,WAAW;IACf;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":["/* Styling for login page */\n\n/* TODO: Responsive styling! */\n\n#login-page {\n    background-image: linear-gradient(var(--yellow), var(--dark-purple));\n    height: 100vh;\n  }\n\n#login-container {\n    width: 100vw;\n    height: 100vh;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n  \n#login-panel {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n\n    padding: 5vw;\n\n    box-shadow: 15px 15px 30px rgba(0, 0, 0, 0.1);\n\n    width: 100%;\n    height: 100%;\n}\n\n#login-greeting, #login-form {\n    width: 50%;\n\n    height: 100%;\n\n    padding: 10px;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n#login-greeting *, #login-form * {\n    width: 70%;\n\n    margin: 0;\n}\n\n#login-greeting {\n    background-color: white;\n    color: black;\n\n    border-radius: 10px 0 0 10px;\n\n    text-align: center;\n\n    gap: 10%;\n}\n\n#login-form form {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n}\n\n#logo-tagline {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    font-weight: normal;\n}\n\n#login-logo {\n    max-width: 100%;\n    margin: 20px;\n}\n\n#expedition-buttons {\n    display: flex;\n    flex-direction: row;\n    /* flex-wrap: wrap; */\n    gap: 25px;\n    justify-content: center;\n}\n\n#expedition-buttons > div {\n    margin: 0;\n    padding: 0;\n}\n\n#expedition-buttons button {\n    margin: 0;\n\n    height: 15vh;\n    width: 15vh;\n\n    border-radius: 10px;\n    border-style: none;\n\n    background-image: linear-gradient(var(--pink), var(--blue));\n\n    color: white;\n}\n\n#login-form {\n    background-color: var(--light-purple);\n    color: white;\n\n    border-radius: 0 10px 10px 0;\n\n    gap: 20px;\n}\n\n#responsive-logo {\n    display: none;\n}\n\n#login-form h3 {\n    font-weight: bold;\n    font-size: 5vh;\n\n    margin: 5px;\n}\n\n#login-form .label {\n    font-size: 3vh;\n}\n\n#login-form #validated-username {\n    font-size: 2.5vh;\n}\n\n.login-credentials {\n    font-size: 3vh;\n\n    padding: 5px;\n    margin-top: 5px !important;\n    margin-bottom: 5px !important;\n\n    width: 100% !important;\n}\n\n#login-button {\n    background-color: var(--yellow)!important;\n    color: white;\n\n    font-size: 3vh;\n\n    border-style: none;\n    border-radius: 5px;\n\n    padding: 10px;\n}\n\n/* Styling for screen sizes under 480px - mobile interface */\n@media screen and (max-width: 800px) {\n    #login-panel {\n        flex-direction: column;\n        width: 85vw;\n        height: 85vh;\n        padding: 0;\n        margin: 0;\n        gap: 0;\n    }\n\n    #login-greeting, #login-form {\n        width: 100%;\n        margin: 0;\n    }\n\n    #login-greeting {\n        /* border-radius: 10px 10px 0 0; */\n        display: none;\n    }\n\n    #logo-tagline h3 {\n        display: none;\n    }\n\n    #login-form {\n        background-color: white;\n        color: black;\n        border-radius: 10px;\n    }\n\n    #responsive-logo {\n        display: block;\n        height: 6vh;\n        width: auto;\n    }\n\n    #login-form > h3 {\n        font-size: 4vh;\n        font-weight: normal;\n    }\n\n    #login-form > p {\n        font-size: 2vh;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
